import { Navigate, Outlet, useMatches } from 'react-router';
import { useSession } from '@/auth/session-context';
import { NoAccess } from '@/components/data/QueryStates';
import { Page, PageHeader } from '@/components/layout/Page';
import { firstAllowedDestination } from './navigation';
import type { RouteHandle } from './routes';

/**
 * Enforces the matched route's declared ability (`routes.tsx`). The API
 * refuses the data anyway; this decides what to show. A role without the
 * landing page's ability is sent to its first allowed destination.
 */
export function RouteGate() {
  const matches = useMatches();
  const { can } = useSession();
  const ability = [...matches].reverse().find((m) => (m.handle as RouteHandle | undefined)?.ability)
    ?.handle as RouteHandle | undefined;

  if (!ability?.ability || can(ability.ability)) return <Outlet />;

  if (matches.at(-1)?.pathname === '/') {
    const destination = firstAllowedDestination(can);
    if (destination && destination !== '/') return <Navigate to={destination} replace />;
  }

  return (
    <Page flush>
      <PageHeader title="No access" />
      <NoAccess ability={ability.ability} />
    </Page>
  );
}
